module.exports = __webpack_public_path__ + "img/pos_s2_icon3.5e173456.png";